import * as React from 'react';

export interface FormProps {
    onSubmit?: (e?: any) => void;
    className?: string;
    validation?: {
        name: string;
        defaultMessage: string,
        validator: (value: any, allData?: any) => boolean 
    }[]
    disabled?: boolean;
}

export interface FormState {
    errors: {
       name: string,
       message: boolean; 
    }[]
}

export default class Form extends React.Component<FormProps, FormState> {
  constructor(props: FormProps) {
    super(props);

    this.state = {
        errors: []
    }
  }

  handleSubmit = (e) => {

    if(e)
        e.preventDefault();

    

    if(this.props.onSubmit && !this.props.disabled)
        this.props.onSubmit(e);
    
  }


  public render() {
    return (
      <form className={'form ' + this.props.className} onSubmit={this.handleSubmit} >
        {this.props.children}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/form.tsx